import React from "react";
import { toAbsoluteUrl } from "../../../../helpers";

export interface TicketCountData {
    all_tickets: number;
    open_tickets: number;
    inprocess_tickets: number;
    closed_tickets: number;
}

interface CardsDashboardTicketsProps {
    className?: string;
    data?: {
        ticket_count?: TicketCountData;
    };
}

const CardsDashboardTickets: React.FC<CardsDashboardTicketsProps> = ({
    className = "",
    data,
}) => {
    return (
        <div
            className={`card card-flush bgi-no-repeat bgi-size-contain bgi-position-x-end h-md-50 mb-5 mb-xl-10  ${className}`}
            style={{

                backgroundColor: "#7239EA",
                backgroundImage: `url('${toAbsoluteUrl("/media/patterns/vector-2.svg")}')`,
            }}
        >
            <div className="card-header pt-5">
                <h3 className="card-title text-white fw-bold">Support Tickets</h3>
                <div className="card-toolbar"></div>
            </div>

            <div className="card-body pt-4">
                <div className="d-flex flex-column content-justify-center flex-row-fluid">
                    <div className="d-flex fw-semibold align-items-center my-3">
                        <div className="text-white flex-grow-1 me-4">All Tickets</div>
                        <div className="fw-bolder text-white text-xxl-end">
                            {data?.ticket_count?.all_tickets ?? 0}
                        </div>
                    </div>
                    <div className="separator separator-dashed my-3"></div>
                    {/* Open Tickets */}
                    <div className="d-flex fw-semibold align-items-center my-3">
                        <div className="text-white flex-grow-1 me-4">Open Tickets</div>
                        <div className="fw-bolder text-white text-xxl-end">
                            {data?.ticket_count?.open_tickets ?? 0}
                        </div>
                    </div>

                    <div className="separator separator-dashed my-3"></div>

                    {/* Closed Tickets */}
                    <div className="d-flex fw-semibold align-items-center my-3">
                        <div className="text-white flex-grow-1 me-4">In Process Tickets</div>
                        <div className="fw-bolder text-white text-xxl-end">
                            {data?.ticket_count?.inprocess_tickets ?? 0}
                        </div>
                    </div>

                    <div className="separator separator-dashed my-3"></div>

                    {/* Closed Tickets */}
                    <div className="d-flex fw-semibold align-items-center my-3">
                        <div className="text-white flex-grow-1 me-4">Closed Tickets</div>
                        <div className="fw-bolder text-white text-xxl-end">
                            {data?.ticket_count?.closed_tickets ?? 0}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CardsDashboardTickets;
